import { supabase } from "../../lib/supabase"

/*
  MEMBERSHIP ANALYTICS SERVICE

  Table used
  africamed_club_applications
*/

/* Total membership applications */
export async function getMembershipCount() {
  const { count, error } = await supabase
    .from("africamed_club_applications")
    .select("*", { count: "exact", head: true })

  if (error) {
    console.error("Membership count error:", error)
    return 0
  }

  return count || 0
}

/* Daily membership applications */
export async function getMembershipDaily() {
  const { data, error } = await supabase
    .rpc("membership_daily_stats")

  if (error) {
    console.error("Membership daily stats error:", error)
    return []
  }

  return (data || []).map(row => ({
    label: row.day,
    value: Number(row.count)
  }))
}

/* Monthly membership applications */
export async function getMembershipMonthly() {
  const { data, error } = await supabase
    .rpc("membership_monthly_stats")

  if (error) {
    console.error("Membership monthly stats error:", error)
    return []
  }

  return (data || []).map(row => ({
    label: row.month,
    value: Number(row.count)
  }))
}

/*
  SITE VISITS ANALYTICS SERVICE

  Table used
  site_visits
*/

/* Total site visits */
export async function getSiteVisitsCount() {
  const { count, error } = await supabase
    .from("site_visits")
    .select("*", { count: "exact", head: true })

  if (error) {
    console.error("Site visits count error:", error)
    return 0
  }

  return count || 0
}

/* Daily site visits */
export async function getSiteVisitsDaily() {
  const { data, error } = await supabase
    .rpc("site_visits_daily_stats")

  if (error) {
    console.error("Site visits daily stats error:", error)
    return []
  }

  return (data || []).map(row => ({
    label: row.day,
    value: Number(row.count)
  }))
}

/* Monthly site visits */
export async function getSiteVisitsMonthly() {
  const { data, error } = await supabase
    .rpc("site_visits_monthly_stats")

  if (error) {
    console.error("Site visits monthly stats error:", error)
    return []
  }

  return (data || []).map(row => ({
    label: row.month,
    value: Number(row.count)
  }))
}

/* Top visited pages */
export async function getTopPages() {
  const { data, error } = await supabase
    .rpc("site_visits_by_page")

  if (error) {
    console.error("Top pages error:", error)
    return []
  }

  return (data || []).map(row => ({
    page: row.page_path,
    visits: Number(row.count)
  }))
}

/* Visits by country */
export async function getVisitsByCountry() {
  const { data, error } = await supabase
    .rpc("site_visits_by_country")

  if (error) {
    console.error("Visits by country error:", error)
    return []
  }

  return (data || []).map(row => ({
    country: row.country,
    visits: Number(row.count)
  }))
}

/* Visits by device type */
export async function getVisitsByDevice() {
  const { data, error } = await supabase
    .rpc("site_visits_by_device")

  if (error) {
    console.error("Visits by device error:", error)
    return []
  }

  return (data || []).map(row => ({
    device: row.device_type,
    visits: Number(row.count)
  }))
}
